function o(t) {
  return /(?:^|\.)systeme\.(?:io|club|local)$/i.test(t);
}
export {
  o as isSioHost
};
